import React, { useState, useEffect } from 'react';

type DIMENTIONS = {
  width: number;
  height: number;
};

export default function useContainerDimensions(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  myRef: React.RefObject<any>
): DIMENTIONS {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const getDimensions = () => ({
      width: (myRef && myRef.current.offsetWidth) || 0,
      height: (myRef && myRef.current.offsetHeight) || 0,
    });

    const handleResize = () => {
      setDimensions(getDimensions());
    };

    if (myRef.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myRef]);

  return dimensions;
}
